module.exports = "/img/_/_/_/assets/images/creeper/battle/common//38.jpg?d24359a087feaeb79a693cadc7d178bb";